import { Accordion } from 'components/Accordion'
import {
  NodePropertyPanelProvider,
  useNodePropertyPanel,
} from 'features/processFlowDiagrams/components/nodes/propertyPanel/NodePropertyPanelContext'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import { PfdNode } from 'types'

import { AppearanceSection } from './sections/AppearanceSection'
import { LinkSection } from './sections/LinkSection'
import { MetadataSection } from './sections/MetadataSection'
import { TransformSection } from './sections/TransformSection'
import {
  PanelContainer,
  PanelHeader,
  PanelPlaceholder,
  PanelWrapper,
  ToggleButton,
} from './StylesAndHelper'

const AccordionTitle = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.forecast.activeText};
`

interface NodePropertyPanelProps {
  selectedNode: PfdNode
}

const PanelContent: React.FC<{ selectedNode: PfdNode }> = ({
  selectedNode,
}) => {
  const { displayPanel, setDisplayPanel } = useNodePropertyPanel()

  const accordionItems = useMemo(
    () => [
      {
        key: 'appearance',
        title: <AccordionTitle>Appearance</AccordionTitle>,
        content: <AppearanceSection />,
      },
      {
        key: 'metadata',
        title: <AccordionTitle>Metadata</AccordionTitle>,
        content: <MetadataSection />,
      },
      {
        key: 'transform',
        title: <AccordionTitle>Transform</AccordionTitle>,
        content: <TransformSection />,
      },
      {
        key: 'link',
        title: <AccordionTitle>Link &amp; Bindings</AccordionTitle>,
        content: <LinkSection selectedNode={selectedNode} />,
      },
    ],
    [selectedNode]
  )

  return (
    <PanelWrapper>
      <ToggleButton onClick={() => setDisplayPanel(!displayPanel)}>
        {displayPanel ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </ToggleButton>

      {displayPanel ? (
        <PanelContainer>
          <PanelHeader>{selectedNode.data.label}</PanelHeader>
          <Accordion items={accordionItems} defaultValue={[]} />
        </PanelContainer>
      ) : (
        <PanelPlaceholder />
      )}
    </PanelWrapper>
  )
}

const NodePropertyPanel: React.FC<NodePropertyPanelProps> = ({
  selectedNode,
}) => {
  return (
    <NodePropertyPanelProvider selectedNode={selectedNode}>
      <PanelContent selectedNode={selectedNode} />
    </NodePropertyPanelProvider>
  )
}

export default NodePropertyPanel
